export function errorMessage(error: any) {
    if (!error) {
        return "";
    } else if (error.type === "required") {
        return "Required";
    } else {
        return error.message;
    }
}